import {
  Button,
  DropdownButton,
  DropdownButtonContext,
  FieldText,
} from '@dixa/lib-shared-habla';
import { Component } from 'react';

type PropsT = {
  onSubmit: (base64string: string) => void;
  toggleDropdown: () => void;
};

type StateT = {
  username: string;
  password: string;
};

class BasicAuthForm extends Component<PropsT, StateT> {
  constructor(props: PropsT) {
    super(props);

    this.state = {
      username: '',
      password: '',
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUpdateUsername = this.handleUpdateUsername.bind(this);
    this.handleUpdatePassword = this.handleUpdatePassword.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleSubmit(event: any) {
    event.preventDefault();
    event.stopPropagation();
    const { onSubmit, toggleDropdown } = this.props;
    const { username, password } = this.state;
    onSubmit(window.btoa(`${username}:${password}`));
    toggleDropdown();
    this.setState({
      username: '',
      password: '',
    });
  }

  handleUpdateUsername(event: any) {
    this.setState({
      username: event.target.value,
    });
  }

  handleUpdatePassword(event: any) {
    this.setState({
      password: event.target.value,
    });
  }

  handleKeyDown(event: any) {
    if (event.key === 'Enter') {
      this.handleSubmit(event);
    }
  }

  render() {
    const { username, password } = this.state;
    return (
      <div onKeyDown={this.handleKeyDown} className="fetchdata-modal-auth">
        <h2>Basic authentication</h2>
        <p>
          Fill in your username and password to create a basic authentication
          header.
        </p>
        <FieldText
          className="fetchdata-modal-auth__field"
          label="Username"
          input={
            { value: username, onChange: this.handleUpdateUsername } as any
          }
          meta={{}}
          placeholder="user"
        />
        <FieldText
          className="fetchdata-modal-auth__field"
          label="Password"
          input={
            { value: password, onChange: this.handleUpdatePassword } as any
          }
          meta={{}}
          type="password"
          placeholder="••••••••"
        />
        <Button type="submit" onClick={this.handleSubmit}>
          Go
        </Button>
      </div>
    );
  }
}

type AuthGeneratorPropsT = {
  fields: any;
};

const AuthGeneratorComponent = ({ fields }: AuthGeneratorPropsT) => {
  const insertHeader = (base64string: string) => {
    fields.push({ key: 'Authorization', value: `Basic ${base64string}` });
  };

  return (
    <DropdownButton
      buttonProps={{ variant: 'tertiary' }}
      dropdown={
        <DropdownButtonContext.Consumer>
          {({ toggleDropdown }) => (
            <BasicAuthForm
              toggleDropdown={toggleDropdown}
              onSubmit={insertHeader}
            />
          )}
        </DropdownButtonContext.Consumer>
      }
    >
      Basic auth
    </DropdownButton>
  );
};
export default AuthGeneratorComponent;
